import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  LABELXMLDATA,
  IXMLData,
  XMLDatas,
} from 'src/interfaces/xmldata.interface';
import { NfsFileModel } from 'src/models/nfsfile.model';
import { DownloaderService } from 'src/services/download/downloader.service';

@Component({
  selector: 'app-visualizer',
  templateUrl: './visualizer.component.html',
  styleUrls: ['./visualizer.component.scss'],
})
export class VisualizerComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: NfsFileModel,
    public dialogRef: MatDialogRef<VisualizerComponent>
  ) {}

  ngOnInit(): void {
    console.log(this.data.xml_data);
  }

  get title() {
    return `Visualização de Nota (${
      this.data.txt_file_name || 'Não identificada!'
    })`;
  }

  get xmls(): XMLDatas[] {
    return this.data.xml_data || [];
  }

  public xml_keys(data: IXMLData) {
    return Object.keys(data);
  }

  public label(key: string) {
    return LABELXMLDATA(key);
  }

  public download() {
    const downloader = new DownloaderService();
    downloader.downloadXML(this.data.txt_file_data, this.data.txt_file_name);
  }

  get erros() {
    return this.data.xml_data_errors;
  }
}
